// LoginModal.js
import React, { useState } from 'react';
import { FaGoogle } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const LoginModal = ({ isOpen, onClose }) => {
   const [email, setEmail] = useState('');
   const [password, setPassword] = useState('');
   const [error, setError] = useState('');
   const [loading, setLoading] = useState(false);
   
   const { login } = useAuth();

   const handleSubmit = async (e) => {
       e.preventDefault();
       // Mock logowania - zawsze przepuszcza
       const mockUser = {
           email: email || 'test@test.com',
           role: 'user',
           name: 'Test User',
           isAuthenticated: true
       };
       
       login(mockUser);
       localStorage.setItem('user', JSON.stringify(mockUser));
       onClose();
   };

   if (!isOpen) return null;

   return (
       <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 px-2 sm:px-4">
           <div className="bg-white p-6 sm:p-8 rounded-lg shadow-2xl max-w-md w-full relative">
               <button
                   onClick={onClose}
                   className="absolute top-3 right-3 text-gray-500 hover:text-gray-900 text-2xl font-bold"
               >
                   ×
               </button>
               <h2 className="text-xl sm:text-2xl font-bold uppercase mb-6 text-center text-[#35530A]">
                   Zaloguj się
               </h2>

               {error && (
                   <div className="mb-4 p-3 bg-red-100 text-red-700 rounded">
                       {error}
                   </div>
               )}

               <form onSubmit={handleSubmit} className="flex flex-col space-y-4">
                   <div>
                       <label className="block text-sm font-medium mb-1 uppercase text-gray-700">
                           Email
                       </label>
                       <input
                           type="email"
                           value={email}
                           onChange={(e) => setEmail(e.target.value)}
                           className="w-full p-2 border border-gray-300 rounded-[2px] focus:outline-none focus:border-[#35530A] focus:ring-1 focus:ring-[#35530A]"
                           placeholder="Podaj swój email"
                       />
                   </div>

                   <div>
                       <label className="block text-sm font-medium mb-1 uppercase text-gray-700">
                           Hasło
                       </label>
                       <input
                           type="password"
                           value={password}
                           onChange={(e) => setPassword(e.target.value)}
                           className="w-full p-2 border border-gray-300 rounded-[2px] focus:outline-none focus:border-[#35530A] focus:ring-1 focus:ring-[#35530A]"
                           placeholder="Podaj hasło"
                       />
                   </div>

                   <button
                       type="submit"
                       className="w-full bg-[#35530A] text-white py-3 rounded-[2px] uppercase text-base font-semibold hover:bg-[#2D4A06] transition-colors"
                   >
                       Zaloguj się
                   </button>

                   <div className="relative flex items-center justify-center mt-4">
                       <div className="absolute inset-0 flex items-center">
                           <div className="w-full border-t border-gray-300"></div>
                       </div>
                       <div className="relative flex justify-center text-sm">
                           <span className="px-2 bg-white text-gray-500">Lub</span>
                       </div>
                   </div>

                   <button
                       type="button"
                       className="w-full flex items-center justify-center gap-2 bg-white border border-gray-300 text-gray-700 py-3 rounded-[2px] uppercase text-base font-semibold hover:bg-gray-50 transition-colors"
                   >
                       <FaGoogle className="text-red-600" />
                       Zaloguj przez Google
                   </button>
               </form>

               <div className="mt-6 text-sm text-center">
                   <Link
                       to="/reset-password"
                       className="text-[#35530A] hover:underline font-semibold uppercase"
                       onClick={onClose}
                   >
                       Odzyskaj hasło
                   </Link>
                   <br />
                   <span className="uppercase text-gray-700">Nie masz konta?</span>{' '}
                   <Link
                       to="/register"
                       className="text-[#35530A] font-semibold hover:underline uppercase"
                       onClick={onClose}
                   >
                       Zarejestruj się
                   </Link>
               </div>
           </div>
       </div>
   );
};

export default LoginModal;